import _ from 'lodash';
import {
  GET_CENTRO_ESPANOL_COURSES,
  GET_CENTRO_ESPANOL_COURSE,
  CREATE_CENTRO_ESPANOL_COURSE,
  UPDATE_CENTRO_ESPANOL_COURSE,
  DISABLE_CENTRO_ESPANOL_COURSE,
  ENABLE_CENTRO_ESPANOL_COURSE
} from '../actions/centroEspanolCoursesActions';

export default function (state = {}, action) {
  switch (action.type) {
    case GET_CENTRO_ESPANOL_COURSES: {
      const coursesData = action.payload.centro_espanol_courses || action.payload.centroEspanolCourses || [];
      const courses = _.mapKeys(coursesData, 'id');
      const pagination = action.payload.links;
      return { ...state, courses, pagination };
    }

    case GET_CENTRO_ESPANOL_COURSE: {
      const course = action.payload.centro_espanol_course || action.payload.centroEspanolCourse;
      return { ...state, course, [course.id]: course };
    }

    case CREATE_CENTRO_ESPANOL_COURSE: {
      const newCourse = action.payload.centro_espanol_course || action.payload.centroEspanolCourse;
      return { ...state, [newCourse.id]: newCourse };
    }

    case UPDATE_CENTRO_ESPANOL_COURSE: {
      const updatedCourse = action.payload.centro_espanol_course || action.payload.centroEspanolCourse;
      return { ...state, [updatedCourse.id]: updatedCourse };
    }

    case DISABLE_CENTRO_ESPANOL_COURSE: {
      const courseId = action.payload;
      const updatedCourses = { ...state.courses };
      if (updatedCourses[courseId]) {
        updatedCourses[courseId] = {
          ...updatedCourses[courseId],
          disabled: true
        };
      }
      return { ...state, courses: updatedCourses };
    }

    case ENABLE_CENTRO_ESPANOL_COURSE: {
      const enabledCourse = action.payload.centro_espanol_course || action.payload.centroEspanolCourse;
      const updatedCoursesForEnable = { ...state.courses };
      if (enabledCourse && enabledCourse.id) {
        updatedCoursesForEnable[enabledCourse.id] = enabledCourse;
      }
      return {
        ...state,
        [enabledCourse.id]: enabledCourse,
        courses: updatedCoursesForEnable
      };
    }

    default:
      return state;
  }
}
